(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-object-types', {
                parent: 'entity',
                url: '/tab-object-types?search',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabObjectTypes.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types.html',
                        controller: 'TabObjectTypesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    device: {
                        value: '-1'
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            device: $stateParams.device,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-object-types-detail', {
                parent: 'tab-object-types',
                url: '/tab-object-types/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-detail.html',
                        controller: 'TabObjectTypesDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-object-types-new', {
                parent: 'tab-object-types',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-dialog.html',
                        controller: 'TabObjectTypesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            objectTypeName: null,
                            objectTypeDescription: null,
                            objectTypeNotes: null,
                            id: null
                        };
                    }
                }
            })
            .state('tab-object-types-edit', {
                parent: 'tab-object-types',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-dialog.html',
                        controller: 'TabObjectTypesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-object-types.delete', {
                parent: 'tab-object-types',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-delete-dialog.html',
                        controller: 'TabObjectTypesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabObjectTypes', function (TabObjectTypes) {
                                return TabObjectTypes.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-object-types', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('object-types-device-releases', {
                parent: 'tab-object-types',
                url: '/{id}/object-types-device-releases',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/object-types-device-releases.html',
                        controller: 'ObjectTypesDeviceReleasesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-object-types-mapping', {
                parent: 'tab-object-types',
                url: '/{id}/mapping',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-mapping.html',
                        controller: 'TabObjectTypesMappingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-object-types-mapping-new', {
                parent: 'tab-object-types-mapping',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabObjectTypes.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-object-types/tab-object-types-mapping-dialog.html',
                        controller: 'TabObjectTypesMappingDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjectTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabObjectTypes', function ($stateParams, TabObjectTypes) {
                        return TabObjectTypes.get({id: $stateParams.id});
                    }]
                }
            });
    }

})();
